import { render, staticRenderFns } from "./InstantMarketingPlaceOrder.vue?vue&type=template&id=abd0c504&"
import script from "./InstantMarketingPlaceOrder.vue?vue&type=script&lang=js&"
export * from "./InstantMarketingPlaceOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports